import Helmet from "react-helmet";
import { Nav, Loading, SupportForm, EditSettings } from "components";
import { SEOSettingsActions } from "actions";
import { SUPPORT_URL } from "consts";

const controlledSettings = [
  "pageTitleTruncateChars",
  "pageTitleEnableAppender",
  "pageTitleAppenderTemplate",
  "pageTitleAppenderTargetLength",

  "pageTitleTemplateApplyToAll",

  "pageTitleTruncateEnableForCollections",
  "pageTitleTruncateEnableForProducts",
  "pageTitleTruncateEnableForPages",
  "pageTitleTruncateEnableForArticles",
  "pageTitleTruncateEnableForBlogs",

  "metaDescriptionTruncateEnableForCollections",
  "metaDescriptionTruncateEnableForProducts",
  "metaDescriptionTruncateEnableForPages",
  "metaDescriptionTruncateEnableForArticles",
  "metaDescriptionTruncateEnableForBlogs",

  "metaDescriptionTruncateChars",
  "metaDescriptionTemplateApplyToAll",

  "metaDescriptionTruncateEnableForCollections",
  "metaDescriptionTruncateEnableForProducts",
  "metaDescriptionTruncateEnableForPages",
  "metaDescriptionTruncateEnableForArticles",
  "metaDescriptionTruncateEnableForBlogs",

  "structuredDataSocialProfileLinks",
  "structuredDataReviewApp",
  "structuredDataDisplayLocalBusiness",
  "structuredDataBusinessName",
  "structuredDataShopUrl",
  "structuredDataBusinessEmail",
  "structuredDataContactPhone",
  "structuredDataStreet",
  "structuredDataLocality",
  "structuredDataRegion",
  "structuredDataCountry",
  "structuredDataPostalCode",
];

export default class SettingsPage extends React.Component {
  static propTypes = {
    settings: React.PropTypes.object,
    fetching: React.PropTypes.bool,
  };

  save(data) {
    debugger;
    let settings = {};
    controlledSettings.forEach((setting) => {
      settings[setting] = data[setting];
    });
    return SEOSettingsActions.update(settings);
  }

  render() {
    if (!this.props.settings) {
      return (
        <div>
          <Helmet title="Page Titles and Meta Descriptions Settings - Plug in SEO Plus" />
          <Nav toolbarTitleText="Page Titles and Meta Descriptions Settings" />
          <Loading />
        </div>
      );
    }

    return (
      <div>
        <Helmet title="Page Titles and Meta Descriptions Settings - Plug in SEO Plus" />
        <Nav toolbarTitleText="Page Titles and Meta Descriptions Settings" />
        <div className="seosettings">
          <div className="seosettings__form-container">
            <EditSettings
              data={this.props.settings}
              saving={this.props.fetching}
              onSave={this.save}
            />
          </div>
          <div className="seosettings__feedback-container">
            <SupportForm
              href={SUPPORT_URL}
              featureType="SEO settings"
              featureKey="settings_structured-data"
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/pages/plus/SettingsPage.js